<template>
  <div ref="bottomNavBox" :class="$style.box" :style="{ height: `${bottomNavHeight}px` }">
    <div
      v-for="item in currentLevelBottomNavArray"
      :key="item.id"
      :ref="`bottomNavItem${item.id}`"
      :class="$style.list"
    >
      <img
        v-if="item.name == '发布按钮'"
        :src="item.images"
        @click="issueTopic(item.id)"
        alt="发布按钮"
      />
      <span
        v-else
        :class="[
          $style['tab-name'],
          isSameNavigationRoute(item.url) && $style.choose,
        ]"
        :ref="`bottomNavName${item.id}`"
        @click="handleLinkTo(item)"
      >
        {{ item.name }}
        <span
          v-if="unreadNumber > 0 && item.name == '消息' ? true : false"
          :class="$style['unread-text']"
        >
          ({{ unreadNumber > 99 ? '99+' : unreadNumber }})
        </span>
        <span
          v-if="shouldShowPopText(item)"
          :ref="`bottomNavPop${item.id}`"
          :class="$style['pop-text']"
          :style="getPopTextStyle(item.id)"
        >
          {{ getPopText(item.remark) }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
let _this = '';
import { getNavigationData } from '@/api/giftCenter';
import { reportData } from '@/api/report';
import { getUserUnreadNumber } from '@/api/personalCenter';
import { localLinkJump } from '@/utils/index.js';
import bottomNavigationMixin from '@/mixins/bottomNavigationMixin.js';
export default {
  mixins: [bottomNavigationMixin],
  props: {
    navigationType: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      bottomNavArray: [],
      routeType: 0,
      currentRouteHash: window.location.hash,
      unreadNumber: '', // 未读消息数
      popTextStyleMap: {},
      bottomNavHeight: 52,
      navigationTypeLoaded: '',
    };
  },
  computed: {
    bottomNavigationType() {
      return Number(this.navigationType) || 1;
    },
    circleId() {
      return this.$route.query.circleId || '';
    },
  },
  watch: {
    $route: {
      handler() {
        this.currentRouteHash = window.location.hash;
        if (String(this.navigationTypeLoaded) !== String(this.bottomNavigationType)) {
          this.bottomNavArray = [];
          this.popTextStyleMap = {};
          this.getBottomNav().then(() => {
            this.dataReport();
          });
        }
        this.getUserUnreadNumber();
        this.$nextTick(() => {
          this.updatePopTextPosition();
        });
      },
      deep: true,
    },
  },
  created() {
    _this = this;
    this.getBottomNav().then(() => {
      this.dataReport();
    });
    this.getUserUnreadNumber();
  },
  mounted() {
    window.addEventListener('resize', this.updatePopTextPosition);
    this.$emit('height-change', this.bottomNavHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updatePopTextPosition);
  },
  methods: {
    // 数组排序(升序)
    sortArray(array) {
      if (!(array instanceof Array)) {
        return;
      }
      let sortArray = [...array];
      sortArray.sort((a, b) => {
        if (a.sort < b.sort) {
          return -1;
        } else if (a.sort > b.sort) {
          return 1;
        }
        return 0;
      });
      return sortArray;
    },
    // 获取底部导航栏
    async getBottomNav() {
      const navigationType = this.bottomNavigationType;
      const r = await getNavigationData({ type: navigationType });
      this.bottomNavArray = Array.isArray(r.data) ? [...r.data] : [];
      this.navigationTypeLoaded = navigationType;
      this.$nextTick(() => {
        this.updatePopTextPosition();
      });
    },
    hasPopText(text) {
      return !!String(text || '').trim();
    },
    isActivityNavigation(item) {
      return Number(this.bottomNavigationType) === 3 || Number(item && item.type) === 3;
    },
    shouldShowPopText(item) {
      return !this.isActivityNavigation(item) && this.hasPopText(item && item.remark);
    },
    getPopText(text) {
      if (!text) return '';
      const textStr = String(text)
        .replace(/\r?\n/g, '')
        .trim();
      if (!textStr) return '';
      const charList = Array.from(textStr);
      if (charList.length <= 10) {
        return textStr;
      }
      return `${charList.slice(0, 9).join('')}...`;
    },
    getRefEl(refName) {
      const ref = this.$refs[refName];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    getPopTextStyle(id) {
      return this.popTextStyleMap[id] || {
        left: '100%',
        maxWidth: 'calc(100vw - 12px)',
        transform: 'none',
      };
    },
    updatePopTextPosition() {
      const styleMap = {};
      const navList = this.currentLevelBottomNavArray;
      const boxEl = this.$refs.bottomNavBox;

      navList.forEach((item, index) => {
        const listEl = this.getRefEl(`bottomNavItem${item.id}`);
        const nameEl = this.getRefEl(`bottomNavName${item.id}`);
        const popEl = this.getRefEl(`bottomNavPop${item.id}`);

        if (!listEl || !nameEl || !popEl) {
          return;
        }

        const nextPopItem = navList
          .slice(index + 1)
          .find(nextItem => this.shouldShowPopText(nextItem));
        const nextPopListEl = nextPopItem
          ? this.getRefEl(`bottomNavItem${nextPopItem.id}`)
          : null;
        const boxWidth =
          (boxEl && boxEl.offsetWidth) || window.innerWidth || listEl.offsetLeft + listEl.offsetWidth;
        const maxRight = nextPopListEl ? nextPopListEl.offsetLeft : boxWidth;
        const availableWidth = Math.max(listEl.offsetWidth, maxRight - listEl.offsetLeft);
        const popWidth = Math.min(popEl.scrollWidth || popEl.offsetWidth, availableWidth);
        const rightTopLeft = nameEl.offsetLeft + nameEl.offsetWidth;
        const maxLeft = Math.max(0, availableWidth - popWidth);
        const popLeft = Math.min(Math.max(rightTopLeft, 0), maxLeft);

        styleMap[item.id] = {
          left: `${popLeft - nameEl.offsetLeft}px`,
          maxWidth: `${availableWidth}px`,
          transform: 'none',
        };
      });
      this.popTextStyleMap = styleMap;
      this.$nextTick(() => {
        this.updateBottomNavHeight();
      });
    },
    updateBottomNavHeight() {
      let maxPopHeight = 0;
      this.currentLevelBottomNavArray.forEach(item => {
        const popEl = this.getRefEl(`bottomNavPop${item.id}`);
        if (popEl) {
          maxPopHeight = Math.max(maxPopHeight, popEl.offsetHeight);
        }
      });

      const baseHeight = 52;
      const popBottom = 34;
      const topPadding = 6;
      const newHeight = Math.max(baseHeight, maxPopHeight + popBottom + topPadding);

      if (newHeight !== this.bottomNavHeight) {
        this.bottomNavHeight = newHeight;
        this.$emit('height-change', newHeight);
      }
    },
    async handleLinkTo(item) {
      const isActivityNav = Number(this.bottomNavigationType) === 3;
      try {
        if (!isActivityNav) {
          await reportData({
            type: 6, // 固定底部导航类型
            navigation_id: item.id,
          });
        }
        await reportData({
          type: 27, // 固定底部导航类型
          data_type: isActivityNav ? 2 : 1, // 1底部导航 2活动导航
          navigation_id: item.id,
          navigation_name: item.name
        });
        // 新增加数据上报
      } catch (error) {
        console.log(error);
      }
      // 外部链接跳转
      if (item.url_type == 2) {
        this.$router.push({
          name: 'giftCenter.activityBridge',
          query: {
            name: item.name || '',
            url: item.url,
            jumpType: isActivityNav ? 'activity' : 'bottom',
            level: item.level || '',
          },
        });
      } else {
        // 内部链接跳转
        localLinkJump(item.url);
      }
    },
    // 点击发布按钮
    issueTopic(id) {
      reportData({
        type: 6,
        navigation_id: id,
      });
      // 2021.11.26 删除了在外页面发布帖子的功能
      if (this.$route.name !== 'gameCircle.home') {
        this.$toast.fail('请去圈子发帖');
        return;
      }
      this.$emit('showTopicField');
    },
    // 获取未读消息数
    async getUserUnreadNumber() {
      const r = await getUserUnreadNumber();
      if (window.location.hash === '#/personalCenter/myNews') {
        this.unreadNumber = 0;
      } else {
        this.unreadNumber = r.data.num;
      }
    },
    // 首次进入页面导航数据上报
    async dataReport() {
      let findItem = this.currentLevelBottomNavArray.find(item =>
        this.isSameNavigationRoute(item.url),
      );
      if (findItem) {
        const r = await reportData({
          type: 6,
          navigation_id: findItem.id,
        });
      }
    },
  },
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  z-index: 98;
  left: 0;
  bottom: 0;
  display: flex;
  width: 100%;
  height: 52px;
  background-color: #fff;
  box-shadow: -3px 0px 10px rgba(159, 159, 159, 1);
  display: flex;
  justify-content: space-around;
  overflow-y: visible;
  .list {
    flex: 1;
    min-width: 0;
    height: 100%;
    line-height: 52px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: rgba(159, 159, 159, 1);
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    > img {
      width: 51px;
    }
    .choose {
      font-size: 16px;
      color: rgba(255, 130, 50, 1);
    }
    .tab-name {
      display: inline-block;
      line-height: 52px;
      position: relative;
      z-index: 1;
    }
    .unread-text {
      color: rgba(245, 42, 42, 1);
    }
    .unread-number {
      position: absolute;
      right: 8px;
      top: 6px;
      width: 20px;
      height: 13px;
      display: inline-block;
      background: rgba(245, 42, 42, 1);
      border-radius: 6px;
      font-size: 8px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 13px;
    }
    .pop-text {
      position: absolute;
      bottom: 34px;
      left: 0px;
      transform: none;
      width: max-content;
      max-width: 100%;
      padding: 0 8px;
      border: 1px solid #FFC554;
      border-radius: 6px 6px 6px 0;
      background: #FFC554;
      font-size: 11px;
      font-weight: 400;
      color: #742600;
      line-height: 15px;
      white-space: normal;
      word-break: break-all;
      text-align: center;
      box-sizing: border-box;
      // box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
      z-index: 3;
      pointer-events: none;
    }
  }
}
</style>
